import React from "react";

const Footer = () => {
  return <div>Made with 🔥</div>;
};

export default Footer;
